export const HOUSING_TYPES = [
  { value: 'apartament_bloc', label: 'Apartament' },
  { value: 'casa_vila', label: 'Casă/Vilă' },
  { value: 'garsoniera', label: 'Garsonieră' },
]

export const FLOOR_OPTIONS = [
  { value: 'ground', label: 'Parter' },
  { value: 'intermediate', label: 'Etaj intermediar' },
  { value: 'top', label: 'Ultimul etaj' },
  { value: 'any', label: 'Indiferent' },
]

export const CONSTRUCTION_YEAR_OPTIONS = [
  { value: 'new', label: 'După 2010' },
  { value: 'recent', label: '2000 - 2010' },
  { value: 'old', label: 'Înainte de 2000' },
  { value: 'any', label: 'Indiferent' },
]

export const ROMANIAN_CITIES = [
  'București',
  'Cluj-Napoca',
  'Timișoara',
  'Iași',
  'Brașov',
  'Constanța',
  'Craiova',
  'Galați',
  'Ploiești',
  'Oradea',
  'Brăila',
  'Arad',
  'Pitești',
  'Sibiu',
  'Bacău',
  'Târgu Mureș',
  'Baia Mare',
  'Buzău',
  'Botoșani',
  'Satu Mare',
]

export const NEIGHBORHOODS_BY_CITY: Record<string, string[]> = {
  București: [
    '13 Septembrie',
    'Apărătorii Patriei',
    'Aviației',
    'Aviatorilor',
    'Balta Albă',
    'Băneasa',
    'Berceni',
    'Brâncoveanu',
    'Bucureștii Noi',
    'Centrul Istoric',
    'Colentina',
    'Cotroceni',
    'Crângași',
    'Domenii',
    'Dorobanți',
    'Dristor',
    'Drumul Taberei',
    'Ferentari',
    'Floreasca',
    'Grozăvești',
    'Iancului',
    'Lujerului',
    'Militari',
    'Moșilor',
    'Obor',
    'Olteniței',
    'Panduri',
    'Pantelimon',
    'Politehnică',
    'Primăverii',
    'Rahova',
    'Regie',
    'Sălăjan',
    'Ștefan cel Mare',
    'Tei',
    'Timpuri Noi',
    'Tineretului',
    'Titan',
    'Unirii',
    'Văcărești',
    'Victoriei',
    'Vitan',
  ],
  'Cluj-Napoca': [
    'Bună Ziua',
    'Centru',
    'Dâmbul Rotund',
    'Gheorgheni',
    'Grigorescu',
    'Între Lacuri',
    'Mănăștur',
    'Mărăști',
    'Zorilor',
  ],
  Timișoara: [
    'Aradului',
    'Bucovina',
    'Circumvalațiunii',
    'Complex Studențesc',
    'Dacia',
    'Fabric',
    'Girocului',
    'Lipovei',
    'Soarelui',
    'Șagului',
  ],
  Iași: [
    'Alexandru cel Bun',
    'Bucium',
    'Bularga',
    'Canta',
    'Centru',
    'Copou',
    'Dacia',
    'Nicolina',
    'Păcurari',
    'Podu Roș',
    'Tătărași',
  ],
  Brașov: [
    'Astra',
    'Avantgarden',
    'Bartolomeu',
    'Centrul Istoric',
    'Noua',
    'Răcădău',
    'Stupini',
    'Tractorul',
    'Valea Cetății',
  ],
  Constanța: [
    'Boreal',
    'Centru',
    'Faleză Nord',
    'Inel I',
    'Inel II',
    'Km 4-5',
    'Km 5',
    'Mamaia',
    'Poarta 6',
    'Tăbăcărie',
    'Tomis Nord',
    'Tomis Plus',
    'Viile Noi',
  ],
  Craiova: [
    '1 Mai',
    'Bariera Vâlcii',
    'Brazda lui Novac',
    'Centru',
    'Craiovița Nouă',
    'Lăpuș',
    'Rovine',
    'Valea Roșie',
  ],
  Galați: [
    'Centru',
    'Dunărea',
    'Mazepa 1',
    'Mazepa 2',
    'Micro 19',
    'Micro 20',
    'Micro 39',
    'Țiglina 1',
    'Țiglina 2',
  ],
  Ploiești: [
    '9 Mai',
    'Albert',
    'Bariera București',
    'Centru',
    'Cioceanu',
    'Malu Roșu',
    'Mihai Bravu',
    'Nord',
    'Sud',
    'Vest',
  ],
  Oradea: [
    'Cantemir',
    'Centru',
    'Decebal',
    'Ioșia',
    'Nufărul',
    'Oncea',
    'Rogerius',
    'Velența',
  ],
  Brăila: [
    'Bariera Călărașilor',
    'Centru',
    'Chercea',
    'Hipodrom',
    'Obor',
    'Radu Negru',
    'Vidin',
  ],
  Arad: [
    'Alfa',
    'Aradul Nou',
    'Bujac',
    'Centru',
    'Confecții',
    'Grădiște',
    'Micălaca',
    'Vlaicu',
  ],
  Pitești: [
    'Centru',
    'Craiovei',
    'Exercițiu',
    'Găvana',
    'Nord',
    'Prundu',
    'Trivale',
    'Tudor Vladimirescu',
  ],
  Sibiu: [
    'Centru',
    'Cireșica',
    'Gușterița',
    'Hipodrom',
    'Lazaret',
    'Ștrand',
    'Turnișor',
    'Valea Aurie',
    'Vasile Aaron',
  ],
  Bacău: [
    'Bistrița Lac',
    'Centru',
    'Cornișa',
    'Gherăiești',
    'Miorița',
    'Nord',
    'Șerbănești',
    'Sud',
  ],
  'Târgu Mureș': [
    '7 Noiembrie',
    'Aleea Carpați',
    'Centru',
    'Cornișa',
    'Dâmbu Pietros',
    'Mureșeni',
    'Tudor',
  ],
  'Baia Mare': [
    'Centru',
    'Ferneziu',
    'Gării',
    'Progresului',
    'Săsar',
    'Vasile Alecsandri',
  ],
  Buzău: ['Broșteni', 'Centru', 'Dorobanți', 'Micro 14', 'Micro 3', 'Micro 5'],
  Botoșani: [
    'Bucovina',
    'Centru',
    'Cismea',
    'Grivița',
    'Primăverii',
    'Sucevei',
  ],
  'Satu Mare': [
    'Carpați',
    'Centru',
    'Micro 14',
    'Micro 17',
    'Soarelui',
    'Solidarității',
  ],
}

export const ESSENTIAL_AMENITIES = [
  'Parcare',
  'Balcon/Terasă',
  'Aer condiționat',
  'Centrală proprie',
  'Pet friendly',
  'Mobilat complet',
  'Electrocasnice incluse',
  'Lift',
]

export const LIVING_MODELS = [
  { value: 'single', label: 'Singur(ă)', icon: 'dots-1' },
  { value: 'couple', label: 'Cuplu', icon: 'dots-2' },
  { value: 'family', label: 'Familie', icon: 'dots-3' },
  {
    value: 'combo',
    label: 'Combo-Rent',
    icon: 'sparkle',
    isNew: true,
    subtitle: 'Vreau să împart o chirie',
  },
]

export const HOUSING_TYPES_ONBOARDING = [
  { value: 'studio', label: 'Garsonieră / Studio' },
  { value: 'apartment', label: 'Apartament' },
  { value: 'house', label: 'Casă / Vilă' },
  { value: 'room', label: 'Cameră (Shared Space)' },
]

export const FLOOR_PREFERENCES = [
  { value: 'any', label: 'Oricare' },
  { value: 'no-ground', label: 'Nu parter' },
  { value: 'no-top', label: 'Nu ultimul etaj' },
  { value: 'middle-only', label: 'Doar etaje intermediare' },
]

export const CONSTRUCTION_YEAR_OPTIONS_ONBOARDING = [
  { value: 'any', label: 'Indiferent' },
  { value: 'new', label: 'Bloc Nou (după 2010)' },
  { value: 'old', label: 'Bloc Vechi (înainte 2010)' },
]

// Landlord-grade construction periods. Used by the PropertyWizard floor+year
// step to describe a specific property's age (not a tenant preference range).
export const CONSTRUCTION_PERIOD_OPTIONS = [
  { value: 'pre-1977', label: 'Înainte de 1977' },
  { value: '1977-1990', label: '1977 – 1990' },
  { value: '1991-2000', label: '1991 – 2000' },
  { value: '2001-2010', label: '2001 – 2010' },
  { value: '2011-2020', label: '2011 – 2020' },
  { value: 'post-2020', label: 'După 2020' },
]

// Floor options for Casă / Vilă. Describes the structure of the house,
// not a position on a stairwell.
export const HOUSE_FLOORS = [
  { value: 'ground-only', label: 'Doar parter' },
  { value: 'p+1', label: 'P+1' },
  { value: 'p+2', label: 'P+2' },
  { value: 'p+3', label: 'P+3 sau mai mult' },
]

export const DURATION_OPTIONS = [
  { value: '1y', label: '1 an' },
  { value: '2y', label: '2 ani' },
  { value: 'indefinite', label: 'Nedeterminat / Mai mult de 2 ani' },
  { value: 'short', label: 'Sub 1 an (Termen scurt/mediu)' },
]

export const AMENITIES_12 = [
  'Centrală termică',
  'Parcare',
  'Aer condiționat',
  'Decomandat',
  'Mobilat complet',
  'Nemobilat',
  'Bucătărie utilată complet',
  'Mașină de spălat vase',
  'Balcon / Terasă',
  'Lift',
  'Aproape de metrou',
  'Contract înregistrat ANAF',
]

export const PET_TYPES = [
  { value: 'dog', label: '🐶 Câine' },
  { value: 'cat', label: '🐱 Pisică' },
  { value: 'other', label: '🦜 Altele' },
]

export const MATCHMAKING_PREFERENCES = [
  { value: 'roommate-m', label: 'Caut coleg de apartament' },
  { value: 'roommate-f', label: 'Caut colegă de apartament' },
  { value: 'coliving', label: 'Deschis la grup (Co-living)' },
]

export const COMBO_TARGET_OPTIONS = [
  { value: 1, label: '1 persoană' },
  { value: 2, label: '2 persoane' },
  { value: 3, label: '3 persoane' },
  { value: 'open', label: 'Deschis (oricâți)' },
]

// L10 — Exhaustive facility catalog for properties (owner-side).
// Source of truth for both:
//   • property creation/edit (PropertyEditorModal)
//   • tenant anunț amenities matching (downstream automatch)
// Three buckets mirror SavedPropertyFacilities { location, essential, preferred }.
export const PROPERTY_FACILITY_CATALOG = {
  location: [
    'Aproape de metrou',
    'Aproape de școală',
    'Aproape de parc',
    'Aproape de spital',
    'Aproape de centru',
    'Zonă liniștită',
    'Vedere panoramică',
    'Vibe rezidențial',
  ],
  essential: [
    'Centrală termică',
    'Mobilat complet',
    'Mobilat parțial',
    'Nemobilat',
    'Aer condiționat',
    'Mașină de spălat',
    'Mașină de spălat vase',
    'Frigider',
    'Cuptor',
    'Bucătărie utilată complet',
    'Internet inclus',
    'Contract ANAF',
  ],
  preferred: [
    'Balcon / Terasă',
    'Lift',
    'Parcare',
    'Garaj',
    'Boxă / Depozitare',
    'Grădină',
    'Curte privată',
    'Pet friendly',
    'Decomandat',
    'Recent renovat',
    'Hot tub',
    'Piscină',
  ],
} as const

export type PropertyFacilityGroup = keyof typeof PROPERTY_FACILITY_CATALOG

// Flat list helper — useful for migrations / validations.
export const ALL_PROPERTY_FACILITIES: string[] = [
  ...PROPERTY_FACILITY_CATALOG.location,
  ...PROPERTY_FACILITY_CATALOG.essential,
  ...PROPERTY_FACILITY_CATALOG.preferred,
]

export const SECTOARE_BUCURESTI: Record<string, string[]> = {
  'Sector 1': [
    'Aviatorilor',
    'Aviației',
    'Băneasa',
    'Domenii',
    'Dorobanți',
    'Floreasca',
    'Primăverii',
    'Victoriei',
  ],
  'Sector 2': [
    'Colentina',
    'Iancului',
    'Moșilor',
    'Obor',
    'Pantelimon',
    'Ștefan cel Mare',
    'Tei',
  ],
  'Sector 3': [
    'Balta Albă',
    'Centrul Istoric',
    'Dristor',
    'Sălăjan',
    'Timpuri Noi',
    'Titan',
    'Unirii',
    'Vitan',
  ],
  'Sector 4': [
    'Apărătorii Patriei',
    'Berceni',
    'Brâncoveanu',
    'Olteniței',
    'Tineretului',
    'Văcărești',
  ],
  'Sector 5': ['13 Septembrie', 'Cotroceni', 'Ferentari', 'Panduri', 'Rahova'],
  'Sector 6': [
    'Bucureștii Noi',
    'Crângași',
    'Drumul Taberei',
    'Grozăvești',
    'Lujerului',
    'Militari',
    'Politehnică',
    'Regie',
  ],
}

export const LOCATION_TREE = ROMANIAN_CITIES.map((city) => {
  if (city === 'București') {
    return {
      label: 'București',
      value: 'București',
      children: Object.entries(SECTOARE_BUCURESTI).map(([sector, zones]) => ({
        label: sector,
        value: `București|${sector}`,
        children: zones.map((zone) => ({
          label: zone,
          value: `București|${sector}|${zone}`,
        })),
      })),
    }
  }
  return {
    label: city,
    value: city,
    children: (NEIGHBORHOODS_BY_CITY[city] || []).map((zone) => ({
      label: zone,
      value: `${city}|${zone}`,
    })),
  }
})

export const CATEGORY_TREE = [
  {
    label: 'Apartament',
    value: 'apartament_bloc',
    children: [
      { label: '1 cameră', value: 'apartament_bloc|1 cam' },
      { label: '2 camere', value: 'apartament_bloc|2 cam' },
      { label: '3 camere', value: 'apartament_bloc|3 cam' },
      { label: '4+ camere', value: 'apartament_bloc|4+ cam' },
    ],
  },
  {
    label: 'Casă / Vilă',
    value: 'casa_vila',
  },
  {
    label: 'Garsonieră',
    value: 'garsoniera',
  },
]

export const SORT_OPTIONS = [
  { value: 'match', label: 'Cea mai bună potrivire' },
  { value: 'urgency', label: 'Cei mai urgenți' },
  { value: 'budget_desc', label: 'Buget descrescător' },
  { value: 'newest', label: 'Cei mai noi' },
]

export const MOVE_IN_OPTIONS = [
  { value: 'any', label: 'Oricând' },
  { value: 'immediate', label: 'Imediat (< 30 zile)' },
  { value: '3months', label: 'În următoarele 3 luni' },
  { value: 'specific', label: 'Lună specifică...' },
]

// --- Credits system (v1 Beta) ---
//
// Flip IS_BETA to false to end the beta — banners disappear automatically and
// new signups stop receiving the free credit grant.

export const IS_BETA = true
export const BETA_FREE_CREDITS = 50

export interface CreditPack {
  id: 'starter' | 'standard' | 'pro'
  name: string
  credits: number
  priceEUR: number
  tagline: string
  recommended?: boolean
}

export const CREDIT_PACKS: CreditPack[] = [
  {
    id: 'starter',
    name: 'Starter',
    credits: 10,
    priceEUR: 5,
    tagline: 'Ideal pentru o închiriere ocazională',
  },
  {
    id: 'standard',
    name: 'Standard',
    credits: 25,
    priceEUR: 10,
    tagline: 'Cel mai bun raport preț/valoare',
    recommended: true,
  },
  {
    id: 'pro',
    name: 'Pro',
    credits: 50,
    priceEUR: 15,
    tagline: 'Pentru proprietari cu portofoliu mai mare',
  },
]

export const AGENT_PRO_PLAN = {
  name: 'Agent PRO',
  pricePerMonth: 29,
  creditsPerMonth: 100,
  features: [
    '100 credite incluse / lună',
    'Badge PRO pe profil',
    'Filtre avansate pentru chiriași',
    'Prioritate la review-uri',
    'Suport dedicat',
  ],
}
